import {
  commandControlIcon,
  commandControlKey,
  optionAltKey,
} from 'conversations/utils/PlaformHelpers'
import { track } from 'shared/store/actions/tracking'

import { GlobalStore as store } from '@driftt/traffic-control'

const noop = () => null

const keyboardTrack = (command: string, isClicked = false) =>
  store.dispatch(
    track({
      name: 'Keyboard Shortcut Used',
      properties: {
        command,
        clicked: isClicked,
      },
    })
  )

export const showAllKeyboardShortcuts = {
  label: `${commandControlIcon()} /`,
  shortcut: `${commandControlKey()}+/`,
  commandKeys: [commandControlIcon(), '/'],
  toast: '',
  track: (isClicked = false) => keyboardTrack('View all keyboard shortcuts', isClicked),
}

const keyboardShortcutsConfig = {
  basic: {
    label: 'Basic',
    bold: {
      label: 'Bold text',
      shortcut: `${commandControlKey()}+b`,
      commandKeys: [commandControlIcon(), 'B'],
      toast: '',
      track: noop,
    },
    italic: {
      label: 'Italicize text',
      shortcut: `${commandControlKey()}+i`,
      commandKeys: [commandControlIcon(), 'I'],
      toast: '',
      track: noop,
    },
    underline: {
      label: 'Underline text',
      shortcut: `${commandControlKey()}+u`,
      commandKeys: [commandControlIcon(), 'U'],
      toast: '',
      track: noop,
    },
    saved_replies: {
      label: 'Insert saved replies',
      shortcut: `${commandControlKey()}+k`,
      commandKeys: [commandControlIcon(), 'K'],
      toast: '',
      track: () => keyboardTrack('saved replies'),
    },
    search: {
      label: 'Search',
      shortcut: `${commandControlKey()}+f`,
      commandKeys: [commandControlIcon(), 'F'],
      toast: '',
      track: () => keyboardTrack('search'),
    },
    slash: {
      label: 'Internal notes & slash commands',
      shortcut: null,
      commandKeys: ['/'],
      toast: '',
      track: noop,
    },
  },
  participants: {
    label: 'Manage participants',
    join: {
      label: 'Join conversation',
      shortcut: 'shift+j',
      commandKeys: ['Shift', 'J'],
      toast: 'Joined conversation',
      track: () => keyboardTrack('join convo'),
    },
    invite: {
      label: 'Invite participants',
      shortcut: 'shift+I',
      commandKeys: ['Shift', 'I'],
      toast: 'Invited participant to conversation',
      track: () => keyboardTrack('invite participant'),
    },
    leave: {
      label: 'Leave conversation',
      shortcut: 'shift+L',
      commandKeys: ['Shift', 'L'],
      toast: 'Left conversation',
      track: () => keyboardTrack('leave convo'),
    },
  },
  status: {
    label: 'Conversation status',
    open: {
      label: 'Mark as open',
      shortcut: `shift+${commandControlKey()}+o`,
      commandKeys: [commandControlIcon(), 'Shift', 'O'],
      toast: 'Marked conversation as open',
      track: () => keyboardTrack('open convo'),
    },
    close: {
      label: 'Mark as closed',
      shortcut: `shift+${commandControlKey()}+c`,
      commandKeys: [commandControlIcon(), 'Shift', 'C'],
      toast: 'Marked conversation as closed',
      track: () => keyboardTrack('close convo'),
    },
    close_leave: {
      label: 'Mark as closed & leave',
      shortcut: `shift+${optionAltKey()}+c`,
      commandKeys: [commandControlIcon(), optionAltKey(), 'C'],
      toast: 'Marked conversation as closed and left',
      track: () => keyboardTrack('close convo & leave'),
    },
    read: {
      skip: true,
      label: 'Mark as read',
      shortcut: 'shift+i',
      commandKeys: ['Shift', 'I'],
      toast: 'Marked conversation as read',
      track: () => keyboardTrack('read'),
    },
    unread: {
      skip: true,
      label: 'Mark as unread',
      shortcut: 'shift+u',
      commandKeys: ['Shift', 'U'],
      toast: 'Marked conversation as unread',
      track: () => keyboardTrack('unread'),
    },
  },
  navigation: {
    label: 'Navigation',
    previous_conversation: {
      label: 'Previous conversation',
      shortcut: `${optionAltKey()}+up`,
      commandKeys: [optionAltKey(), '⬆'],
      toast: '',
      track: () => keyboardTrack('previous convo'),
    },
    next_conversation: {
      label: 'Next conversation',
      shortcut: `${optionAltKey()}+down`,
      commandKeys: [optionAltKey(), '⬇'],
      toast: '',
      track: () => keyboardTrack('next convo'),
    },
    previous_unread: {
      skip: true,
      label: 'Previous unread',
      shortcut: `shift+${commandControlKey()}+up`,
      commandKeys: [commandControlIcon(), 'Shift', '⬆'],
      toast: '',
      track: () => keyboardTrack('previous unread'),
    },
    next_unread: {
      skip: true,
      label: 'Next unread',
      shortcut: `shift+${commandControlKey()}+down`,
      commandKeys: [commandControlIcon(), 'Shift', '⬇'],
      toast: '',
      track: () => keyboardTrack('next unread'),
    },
    previous_section: {
      skip: true,
      label: 'Previous section',
      shortcut: `${commandControlKey()}+up`,
      commandKeys: [commandControlIcon(), '⬆'],
      toast: '',
      track: () => keyboardTrack('previous section'),
    },
    next_section: {
      skip: true,
      label: 'Next section',
      shortcut: `${commandControlKey()}+down`,
      commandKeys: [commandControlIcon(), '⬇'],
      toast: '',
      track: () => keyboardTrack('next section'),
    },
  },
}

export default keyboardShortcutsConfig
